import React from 'react'
import { Form } from 'react-bootstrap'

interface GroupCheckboxProps {
  options: string[]
  selectedOptions: string[]
  onToggle: (options: string[], allEnabled: boolean) => void
}

export const GroupCheckbox: React.FC<GroupCheckboxProps> = ({ options, selectedOptions, onToggle }) => {
  const enabledInGroup = options.filter((e) => selectedOptions.includes(e))
  const allEnabled = enabledInGroup.length === options.length
  const someEnabled = enabledInGroup.length > 0 && !allEnabled

  return (
    <Form.Check
      className='d-flex align-items-center'
      ref={(el) => {
        if (el) el.indeterminate = someEnabled
      }}
      type='checkbox'
      checked={allEnabled}
      onChange={() => onToggle(options, allEnabled)}
    />
  )
}
